module.exports = __webpack_public_path__ + "img/IE.7dc27057.svg";